<template>
  <div class="container top-0 position-sticky z-index-sticky">
    <div class="row">
      <div class="col-12">
        <navbar
          isBlur="blur  border-radius-lg my-3 py-2 start-0 end-0 mx-4 shadow"
          v-bind:darkMode="true"
          isBtn="bg-gradient-success"
        />
      </div>
    </div>
  </div>
  <main class="mt-0 main-content">
    <section>
      <div class="page-header min-vh-100">
        <div class="container">
          <div class="row">
            <div class="mx-auto col-xl-4 col-lg-5 col-md-7 d-flex flex-column mx-lg-0">
              <div class="card card-plain">
                <div class="pb-0 card-header text-start">
                  <h4 class="font-weight-bolder">Log in</h4>
                  <p class="mb-0">Masukkan email dan password</p>
                </div>
                <div class="card-body">
                  <div class="mb-3">
                      <argon-input type="text" placeholder="Username" v-model:value="username" name="username" size="lg" @keyup.enter="login" />
                    </div>
                    <div class="mb-3">
                      <argon-input type="password" placeholder="Password" v-model:value="password" name="password" size="lg" @keyup.enter="login" />
                    </div>
                    <div class="mb-3" v-if="error != ''">
                      <argon-alert color="danger">
                        {{ error }}
                      </argon-alert>
                    </div>

                    <div class="text-center">
                      <argon-button
                        class="mt-4"
                        variant="gradient"
                        color="success"
                        fullWidth
                        size="lg"
                        @click="login"
                      >Sign in</argon-button>
                    </div>
                    <div class="text-center mt-3">
                      <argon-button
                        variant="outline"
                        color="secondary"
                        fullWidth
                        size="lg"
                        @click="goToLaporan"
                      >Lihat Laporan</argon-button>
                    </div>
                </div>
              </div>
            </div>
            <div
              class="top-0 my-auto text-center col-6 d-lg-flex d-none h-100 pe-0 position-absolute end-0 justify-content-center flex-column"
            >
              <div
                class="position-relative bg-gradient-primary h-100 m-3 px-7 border-radius-lg d-flex flex-column justify-content-center overflow-hidden"
                style="background-image: url('./img/logo2.png');
                background-size: contain;
                background-position: center;
                background-repeat: no-repeat;"
              >
                <span class="mask bg-gradient-success opacity-6"></span>
                <h4
                  class="mt-5 text-white font-weight-bolder position-relative"
                >Sistem Pendataan Jemaat</h4>
                <p
                  class="text-white position-relative"
                >GKPB Jemaat Kristus Kasih</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  </main>
</template>

<script>
/* eslint-disable */
import Navbar from "@/examples/PageLayout/Navbar.vue";
import ArgonInput from "@/components/ArgonInput.vue";
import ArgonButton from "@/components/ArgonButton.vue";
import ArgonAlert from "@/components/ArgonAlert.vue";
const body = document.getElementsByTagName("body")[0];

export default {
  name: "signin",
  components: {
    Navbar,
    ArgonAlert,
    ArgonInput,
    ArgonButton,
  },
  data() {
    return {
      username: "",
      password: "",
      error:"",
    }
  },
  created() {
    this.$store.state.hideConfigButton = true;
    this.$store.state.showNavbar = false;
    this.$store.state.showSidenav = false;
    this.$store.state.showFooter = false;
    body.classList.remove("bg-gray-100");
  },
  beforeUnmount() {
    this.$store.state.hideConfigButton = false;
    this.$store.state.showNavbar = true;
    this.$store.state.showSidenav = true;
    this.$store.state.showFooter = true;
    body.classList.add("bg-gray-100");
  },
  methods: {
    login(){
      this.error = '';
      this.$http.post(process.env.VUE_APP_API_URL + "login",{
        "username": this.username,
        "password": this.password
      }).then((resp) => {
        localStorage.setItem("token",resp.data.success.token)
        const user = resp.data.success.user
        this.$store.commit('setUser', user)
        if(user.role === 2 || user.role === 3){
          this.$router.push("/data-jemaat")
        } else {
          this.$router.push("/dashboard")
        }
      }).catch((resp) => {
        this.error = resp.response.data.error
        console.log(resp)
      })
    },
    goToLaporan(){
      this.$router.push("/laporan")
    }
  }
};
</script>
